import React from "react";
import icon from "./icon/link.png";
import Img1 from "../Home/img_pro/webp/Plafond acoustique textile suspendu pour piscine olympique – solution architecturale UNIK SYSTEM.webp"
import Img2 from "../Home/img_pro/webp/SLIDE_oxygene-experience-spa-casablanca-2.webp";
import Img3 from "../Home/img_pro/webp/IMG-20231111-WA0013.webp";
import Img4 from "../Home/img_pro/webp/GARE-LGV-AGDAL-2024-01-30-a-09.36-1.webp";
import Img5 from "../Home/img_pro/2Technicien UNIK SYSTEM.jpg";
import Img6 from "../Home/img_pro/webp/qq.webp";


const SectionMetier = () => {
  
  const data = [
    {
      title: (<><i class="fa-solid fa-layer-group me-2"></i>Solutions plafonds et murs tendus</>),
      img: Img2,
      text: [
        "Nous proposons des solutions haut de gamme en toile tendue polyester ou PVC, imprimée ou rétroéclairée.  Idéales pour un rendu élégant, propre et durable.",],
      link: "/PlafondsMursTendus",
      
    },
    {
      title: (<><i className="fa-solid fa-lightbulb me-2"></i>Solutions Lumineuses</>),
      img: Img4,
      text: [
        "Les solutions US LIGHT développées par UNIK SYSTEM permettent d’intégrer la lumière au cœur de l’architecture intérieure grâce à des toiles rétroéclairées, panneaux lumineux, systèmes LED, lightbox, suspensions décoratives, baffles lumineux, totems en feutrine, et bien plus encore.",
      ],
      link: "/SolutionLight",
    },
    {
      title: (<><i className="fa-solid fa-volume-low me-2"></i>Solutions acoustiques</>),
      img: Img1,
      text: [
        
        "Optimisez le confort sonore avec nos solutions acoustiques : toiles tendues micro-perforées, panneaux en feutrine décorative et systèmes absorbants sur mesure. Une acoustique performante, un design moderne.",
      ],
      link: "/SolutionAcoustique",
    },
    {
      title: (<><i class="fas fa-paint-brush"></i> Solutions Art Deco</>),
      img: Img6,
      text: [
        "Solution Art Déco est une approche créative dédiée à la valorisation esthétique des espaces intérieurs et extérieurs. Elle combine design moderne, matériaux innovants et finitions artistiques pour offrir des réalisations uniques et élégantes.",
      ],
      link: "/SolutionArtDeco",
    },
    
    {
      title: (<><i className="fa-solid fa-sun me-2"></i>Solutions Protection solaire</>),
      img: Img5,
      text: [
        "Nous proposons des solutions de protection solaire performantes et esthétiques, conçues pour maîtriser la lumière, réduire la chaleur et améliorer le confort thermique."
      ],
      link: "/ProtectionSolaire",
    },
    {
      title: (<><i className="fa-solid fa-compass-drafting me-2"></i>Solutions Architecture textile</>),
      img: Img3,
      text: [
        "Structures aluminium & métal avec membranes techniques hautes performances. Des solutions durables, modernes et entièrement sur mesure."
      ],
      link: "/ArchitectureTextil",
    },
  ];

  return (
    <div className="Metier" id="Metier">
        <div className="text-center mx-auto mb-5 projects-header">
        <h1 className="section-titles"><span className="section-titles-2">NOS</span> METIERS</h1>
        <p className="display-8">Découvrez nos metiers</p>
      </div>
      <div className="container-metier">
        
        {data.map((item, index) => (
          <div data-aos="flip-up" className="box-metier" key={index}>
            <div  className="imgBx">
              <h4 className="img-title">{item.title}</h4>
              <img src={item.img} alt={item.title} />
            </div>

            <div className="content">
              <div>
                <h3>{item.title}</h3>

                {item.text.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}

                <a className="btn-metier" href={item.link}>
                  <img className="icon-link-metier" src={icon} alt="" />
                </a>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionMetier;
